module.exports = __webpack_public_path__ + "static/img/成一-于志明.c80219a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成一-于志明.jpg
// module id = DUJT
// module chunks = 1